// extracted by mini-css-extract-plugin
export default {"root":"styles_root__srsNY","tag":"styles_tag__rfmzh","tag-overflow":"styles_tag-overflow__1F2mj"};